export const scrollIntoViewWithOffset = (
  target: HTMLElement,
  yOffset: number
): void => {
  const y = target.getBoundingClientRect().top + window.scrollY + yOffset

  console.error('scroll to:', y)
  window.scrollTo({ top: y, behavior: 'smooth' })
}
